import Joi from 'joi';

const details = {
  name: Joi.string()
    .label('Template Name')
    .min(3)
    .max(100)
    .required(),
  layout: Joi.string()
    .required()
    .label('Template Layout'),
  schemaIdentifier: Joi.string()
    .label('Event Type')
    .required()
};

const design = {
  id: Joi.string(),
  emailSubject: Joi.string()
    .required()
    .label('Email Subject'),
  jsonContent: Joi.any()
};

export default {
  details,
  design,
  all: {
    ...design,
    ...details
  }
};
